module.exports = __webpack_public_path__ + "media/icons/sentiment_satisfied-67b208ed.svg";